import type { IUserSubscriptions } from "~common/types/user";
import { IUserState, ELoginState, IUserSetting, ESETTINGS_KEYS } from "./interfaces";
import { CONFIG } from "~/config";

const DEFAULT_USER_SETTINGS: Array<IUserSetting> = [{
	id: "def",
	title: ESETTINGS_KEYS.SEARCH_MAP_SUPPRESSION,
	public: false,
	/* eslint-disable camelcase */
	create_time: Date.now(),
	update_time: Date.now(),
	/* eslint-enable camelcase */
	deleted: false,
	type: "settings",
	data: {
		value: true,
		type: "boolean",
	},
}];

const INITIAL_USER_SETTINGS: Array<IUserSetting> = [{
	id: "def",
	title: ESETTINGS_KEYS.SEARCH_MAP_SUPPRESSION,
	public: false,
	/* eslint-disable camelcase */
	create_time: Date.now(),
	update_time: Date.now(),
	/* eslint-enable camelcase */
	deleted: false,
	type: "settings",
	data: {
		value: CONFIG.mapSuppression,
		type: "boolean",
	},
}];

if (CONFIG.routeDefaultCriterion) {
	INITIAL_USER_SETTINGS.push({
		id: "def",
		title: ESETTINGS_KEYS.ROUTING_WEB_DEFAULT_CRITERION,
		public: false,
		/* eslint-disable camelcase */
		create_time: Date.now(),
		update_time: Date.now(),
		/* eslint-enable camelcase */
		deleted: false,
		type: "settings",
		data: {
			value: CONFIG.routeDefaultCriterion,
			type: "number",
		},
	});
}

export const DEFAULT_PREMIUM_DATA: IUserSubscriptions = {
	subscriptions: [],
	profile: {
		id: "",
		language: "",
		country: "",
		region: "",
		zip: "",
		offlineMaps: [],
		isPilotUser: false,
		isTrialAvailable: false,
	},
	features: {
		/* eslint-disable camelcase */
		advanced_mymaps: false,
		advanced_routing: false,
		offline_map_count: 0,
		premium_support: false,
		user_badge: false,
		watch_support: false,
		watch_support2: false,
		/* eslint-enable camelcase */
	},
	availableProducts: [],
};

export const DEFAULT_USER_STATE: IUserState = {
	user: {
		name: "",
		username: "",
		rusId: 0,
		state: ELoginState.Red,
		avatar: "",
		userPublicId: "",
		bankId: false,
		accountDisplayName: "",
		phoneOnly: false,
		sbr: false,
		premium: false,
		premiumData: JSON.parse(JSON.stringify(DEFAULT_PREMIUM_DATA)),
	},
	accounts: [],
	settings: DEFAULT_USER_SETTINGS,
	notifications: {
		total: 0,
		totalNew: 0,
	},
};

export const INITIAL_USER_STATE: IUserState = CONFIG.user
	? {
		user: {
			name: CONFIG.user.name,
			username: CONFIG.user.accountDisplayName,
			rusId: CONFIG.user.rusId,
			state: CONFIG.user.state,
			avatar: CONFIG.user.avatar,
			userPublicId: CONFIG.user.userPublicId,
			bankId: CONFIG.user.bankId,
			accountDisplayName: CONFIG.user.accountDisplayName,
			phoneOnly: CONFIG.user.phoneOnly,
			sbr: CONFIG.user.sbr,
			premium: CONFIG.user.premium,
			premiumData: CONFIG.user.premiumData
				? {
					subscriptions: [...Array.isArray(CONFIG.user.premiumData.subscriptions) ? CONFIG.user.premiumData.subscriptions : DEFAULT_PREMIUM_DATA.subscriptions],
					features: {
						/* eslint-disable camelcase */
						advanced_mymaps: CONFIG.user.premiumData.features?.advanced_mymaps || DEFAULT_PREMIUM_DATA.features.advanced_mymaps,
						advanced_routing: CONFIG.user.premiumData.features?.advanced_routing || DEFAULT_PREMIUM_DATA.features.advanced_routing,
						offline_map_count: CONFIG.user.premiumData.features?.offline_map_count || DEFAULT_PREMIUM_DATA.features.offline_map_count,
						premium_support: CONFIG.user.premiumData.features?.premium_support || DEFAULT_PREMIUM_DATA.features.premium_support,
						user_badge: CONFIG.user.premiumData.features?.user_badge || DEFAULT_PREMIUM_DATA.features.user_badge,
						watch_support: CONFIG.user.premiumData.features?.watch_support || DEFAULT_PREMIUM_DATA.features.watch_support,
						watch_support2: CONFIG.user.premiumData.features?.watch_support2 || DEFAULT_PREMIUM_DATA.features.watch_support2,
						/* eslint-enable camelcase */
					},
					profile: {
						language: CONFIG.user.premiumData.profile?.language || DEFAULT_PREMIUM_DATA.profile.language,
						country: CONFIG.user.premiumData.profile?.country || DEFAULT_PREMIUM_DATA.profile.country,
						region: CONFIG.user.premiumData.profile?.region || DEFAULT_PREMIUM_DATA.profile.region,
						zip: CONFIG.user.premiumData.profile?.zip || DEFAULT_PREMIUM_DATA.profile.zip,
						offlineMaps: CONFIG.user.premiumData.profile?.offlineMaps || DEFAULT_PREMIUM_DATA.profile.offlineMaps,
						isPilotUser: CONFIG.user.premiumData.profile?.isPilotUser || DEFAULT_PREMIUM_DATA.profile.isPilotUser,
						isTrialAvailable: CONFIG.user.premiumData.profile?.isTrialAvailable || DEFAULT_PREMIUM_DATA.profile.isTrialAvailable,
						id: CONFIG.user.premiumData.profile?.id || DEFAULT_PREMIUM_DATA.profile.id,
					},
					availableProducts: [...Array.isArray(CONFIG.user.premiumData.availableProducts) ? CONFIG.user.premiumData.availableProducts : DEFAULT_PREMIUM_DATA.availableProducts],
				}
				: JSON.parse(JSON.stringify(DEFAULT_PREMIUM_DATA)),
		},
		accounts: [],
		settings: INITIAL_USER_SETTINGS,
		notifications: { ...DEFAULT_USER_STATE.notifications },
	}
	: DEFAULT_USER_STATE;
